import { create } from '../../../utils/createStore.js';

/**
 * Small, scoped Zustand store for file upload progress state on the Efforts
 * dashboard. Kept separate from the filters store per the small-stores rule.
 */
export const useUploadProgress = create((set) => ({
  isUploading: false,
  progress: 0,
  error: null,

  startUpload: () => set({ isUploading: true, progress: 0, error: null }),
  setProgress: (progress) => set({ progress }),
  finishUpload: () => set({ isUploading: false, progress: 100 }),
  failUpload: (error) => set({ isUploading: false, error }),
  reset: () => set({ isUploading: false, progress: 0, error: null }),
}));
